import { CoreIcon } from '../core-icon';
import zoomInSVG from '../../assets/icons/zoom-in.svg';
import type { IconProps } from '../core-icon';

export const ZoomInIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={zoomInSVG} {...props} />;
};
